/** @jsx jsx */
import FormContents from 'components/atoms/Form/FormContents';
import { jsx, css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormLabel from 'components/atoms/Form/FormLabel';
import DatePickerForm from 'components/molecules/DatePickerForm';
import OrganizationFilteredTree from 'components/organismos/organization/OrganizationFilteredTree/OrganizationFilteredTree';
import BlockUI from 'components/molecules/BlockUi';
import useDailySalesManage from './hook';
import DailySalesManagementTable from './DailySalesManagementTable';

const DailySalesManageLayout = () => {
  const {
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    functionType,
    staffCode,
    orgCode,
    orgName,
    setorgName,
    setOrgCode,
    categoryAry,
    setCategoryAry,
    isLoading,
    setIsLoading,
    targetPeriodData,
    dailyReport,
    setDailyReport,
    getMediaMst,
    getCreditMst,
    checkUserRole,
  } = useDailySalesManage();
  return (
    <BlockUI blocking={isLoading}>
      <FormContents>
        <FlexBox>
          <FlexBoxItem width="100px">
            <FormLabel
              label="営業日"
            />
          </FlexBoxItem>
          <FlexBoxItem>
            <DatePickerForm
              dateFormat="yyyy年MM月dd日"
              label=""
              date={targetDateFrom}
              changeDate={(date: Date) => {
                if (date !== null) {
                  setTargetDateFrom(date);
                }
              }}
              isFullWidth={true}
            />
          </FlexBoxItem>
          <FlexBoxItem>
            <span style={{ margin: '0 30px' }}>～</span>
          </FlexBoxItem>
          <FlexBoxItem>
            <DatePickerForm
              dateFormat="yyyy年MM月dd日"
              label=""
              date={targetDateTo}
              changeDate={(date: Date) => {
                if (date !== null) {
                  setTargetDateTo(date);
                }
              }}
              isFullWidth={true}
            />
          </FlexBoxItem>
        </FlexBox>
        <FlexBox>
          <FlexBoxItem width="50%">
            <OrganizationFilteredTree
              orgLabel="組織"
              isAlignItemsCenter={true}
              functionType={functionType}
              staffCode={staffCode}
              addAllItem={true}
              initOrgValue={String(orgCode)}
              orgCallback={(args: any) => {
                if (args === 'all') {
                  setDailyReport([]);
                }
                setOrgCode(String(args));
              }}
              orgCategoryCallback={(args: Array<string>) => {
                setCategoryAry(args);
              }}
              orgNameCallback={(arg: any) => {
                setorgName(String(arg));
              }}
            />
          </FlexBoxItem>
        </FlexBox>
        <FlexBox>
          <FlexBoxItem width="100%">
            <DailySalesManagementTable
              targetDateFrom={targetDateFrom}
              targetDateTo={targetDateTo}
              dailyReport={dailyReport}
              getMediaMst={getMediaMst}
              getCreditMst={getCreditMst}
              targetPeriodData={targetPeriodData}
              orgLabel={orgName}
              orgCode={orgCode}
              categoryAry={categoryAry}
              checkUserRole={checkUserRole}
              loadingCallback={(args: any) => {
                setIsLoading(args);
              }}
            />
          </FlexBoxItem>
        </FlexBox>
      </FormContents>
    </BlockUI>
  );
};

export default DailySalesManageLayout;
